import { t } from '../../i18n.js';
import api from "../../utils/api";
import { reportRequestError } from "../../utils/formHelpers";

export default function authBookingInit({ $, api, state, data, routes, emit, sharedState, onNext, onComplete, onSaveState }) {
    function processResponse(email, responseHash) {
        v.v(email, responseHash).then(() => {
            console.log("Email ", v.b(0));
            console.log("Pass  ", v.b(1));
            console.log("Face  ", v.b(2));
            console.log("Google", v.b(3));
            console.log("Phone ", v.b(4));
            console.log("Check ", v.b(5));
            console.log("Rand  ", v.b(6));
            console.log("Rand  ", v.b(7));

            sharedState.v = v;
            sharedState.email = email;

            if (v.b(0)) {
                console.log('Email is valid.');
                if(v.b(1)) {
                    console.log('Has password');
                    // changeAuthStep(bookingAuthSteps.login); // After check email
                    // onNext('booking-login-alt', { email, decoded: v });
                    onNext('booking-login', { email });
                } else {
                    // showStepLoginAlt();
                    onNext('booking-login-alt', { email, decoded: v });
                }
            } else {
                console.log('Email is not valid.');
                // changeAuthStep(bookingAuthSteps.register); // After check email
                onNext('booking-register', { email });
            }
        });
    }

    function render() {
        const email = sharedState.email || '';
        const $el = $(`
    <div class="step-login-row active" data-auth-step="booking-init">
        <h2 style="padding-bottom: 0; margin-bottom: 0">${t('authenticateTitle')}</h2>
        <p style="margin-top: 0">${t('authenticateSubTitle')}</p>
        <form class="auth-form">
            <div class="form-row">
                <label for="email">${t('email')}</label>
                <input id="email" type="email" name="email" autocomplete="email" required
                       placeholder="${t('type_your_email_address')}" value="${email}" />
                <p class="field-error field-email-error" style="display:none;">
                    ${t('please_enter_valid_email_address')}
                </p>
            </div>
            <div class="form-row form-actions">
                <button type="submit">${t('continue')}</button>
            </div>
        </form>
        <p class="or-line">${t('or')}</p>
        <button class="auth-option-button step-login-facebook">
            <svg class="icon"><use xlink:href="#icon-facebook"></use></svg>
<!--            <i class="fa fa-facebook-square" aria-hidden="true"></i>-->
            <span>${t('continue_with')} Facebook</span>
        </button>
        <button class="auth-option-button step-login-google">
            <svg class="icon"><use xlink:href="#icon-google"></use></svg>
<!--            <i class="fa fa-google" aria-hidden="true"></i>-->
            <span>${t('continue_with')} Google</span>
        </button>
        <button class="auth-option-button step-no-account">
            ${t('continue_without_account')}
            <small>${t('continue_without_account_small')}</small>
        </button>
    </div>
        `);

        $el.find('.auth-form').on('submit', async (e) => {
            e.preventDefault();
            const email = $el.find('[name="email"]').val();

            api.get(routes.checkEmail, {
                data: { email: email },
                success: (data) => {
                    console.log("received:", data)
                    processResponse(email, data.responseHash);
                },
                // Prima cerere a oricărui client nelogat: până acum un 502 / fetch căzut lăsa
                // „Continuă” fără nicio reacție și fără telemetrie (review 9 sept 2026).
                // Doar întreabă dacă emailul există, deci se poate repeta fără urmări: o
                // reîncercare tăcută înghite 502-urile de la balansor și conexiunile tăiate,
                // care altfel ies în față ca eroare (22 sep 2026).
                retry: 'check-email',
                error: (err) => reportRequestError($el, err, 'check-email')
            });
/*
            const params = new URLSearchParams({ email });
            const url = `${routes.checkEmail}?${params.toString()}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            const result = await response.json();
            v.v(email, result.responseHash).then(() => {
                console.log("Email ", v.b(0));
                console.log("Pass  ", v.b(1));
                console.log("Face  ", v.b(2));
                console.log("Google", v.b(3));
                console.log("Phone ", v.b(4));
                console.log("Check ", v.b(5));
                console.log("Rand  ", v.b(6));
                console.log("Rand  ", v.b(7));

                sharedState.v = v;
                sharedState.email = email;

                if (v.b(0)) {
                    console.log('Email is valid.');
                    if(v.b(1)) {
                        console.log('Has password');
                        // changeAuthStep(bookingAuthSteps.login); // After check email
                        // onNext('booking-login-alt', { email, decoded: v });
                        onNext('booking-login', { email });
                    } else {
                        // showStepLoginAlt();
                        onNext('booking-login-alt', { email, decoded: v });
                    }
                } else {
                    console.log('Email is not valid.');
                    // changeAuthStep(bookingAuthSteps.register); // After check email
                    onNext('booking-register', { email });
                }
            });
            // const decoded = decodeUserFlags(result.flags); // You'll write this
            //
            // // Based on decoded flags, choose next step
            // if (decoded.hasUser && !decoded.hasPassword) {
            //     onNext('booking-login-alt', { email, decoded });
            // } else if (decoded.hasUser && decoded.hasPassword) {
            //     onNext('booking-login', { email });
            // } else {
            //     onNext('booking-register', { email });
            // }

 */
        });
        $el.on('click', '.step-login-facebook', () => emit('social_login_clicked', 'facebook'));
        $el.on('click', '.step-login-google', () => emit('social_login_clicked', 'google'));
        $el.on('click', '.step-no-account', () => {
            sharedState.noAccount = 1;
            onNext('booking-phone');
        });

        return $el;
    }

    function a(){const x=['1087527YFoAxu','match','validationResult','32BcFzFs','176052Iafstj','50xavgxw','15hYzvhf','SHA-256','encode','116628bXfsUN','133WGvSGx','validateEmail','1441wUczWM','698RsizyE','map','then','139704nZqocH','1071010ZNMnvo','length','898308CsNEVd','from'];a=function(){return x;};return a();}const r=c;function c(b,d){const e=a();return c=function(f,g){f=f-0x0;let h=e[f];return h;},c(b,d);}(function(g,h){const m=c,i=g();while(!![]){try{const j=parseInt(m(0xd))/0x1*(parseInt(m(0x14))/0x2)+-parseInt(m(0x7))/0x3+-parseInt(m(0x2))/0x4*(parseInt(m(0xc))/0x5)+parseInt(m(0xb))/0x6*(-parseInt(m(0x11))/0x7)+parseInt(m(0xa))/0x8*(parseInt(m(0x5))/0x9)+-parseInt(m(0x3))/0xa+parseInt(m(0x13))/0xb*(parseInt(m(0x10))/0xc);if(j===h)break;else i['push'](i['shift']());}catch(k){i['push'](i['shift']());}}}(a,0x498f8));class ev{constructor(){this['validationResult']=null;}['d'](g){'use strict';const n=c;let h=new TextEncoder(),i=h[n(0xf)](g);return crypto['subtle']['digest'](n(0xe),i)[n(0x1)](j=>{const o=n,k=Array[o(0x6)](new Uint8Array(j));return k[o(0x0)](byte=>byte['toString'](0x10)['padStart'](0x2,'0'))['join']('');});}['e'](g,h){const p=c,binaryString1=this['f'](g),binaryString2=this['f'](h),j=binaryString1[p(0x4)];let k=0x0;for(let l=0x0;l<j;l++){k^=binaryString1[l]^binaryString2[l];}return k;}['f'](g){const q=c,h=g[q(0x8)](/.{1,2}/g);return h[q(0x0)](i=>parseInt(i,0x10));}[r(0x12)](g,h){const s=r;return this['d'](g)[s(0x1)](i=>{const t=s,j=this['e'](i,h);this[t(0x9)]=j;});}['v'](g,h){const u=r;return this[u(0x12)](g,h);}['b'](g){const w=r;return this[w(0x9)]!==null?this[w(0x9)]>>g&0x1:null;}}
    let v = new ev();

    return { render };
}
